import React from 'react';
import { Spread } from '../../types/spread';
import ClockIcon from '../../assets/icons/ClockIcon';
import WarningIcon from '../../assets/icons/WarningIcon';

const VideoIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: 6, flexShrink: 0 }}
  >
    <path d="M15 10l4.553-2.069A1 1 0 0 1 21 8.87v6.26a1 1 0 0 1-1.447.894L15 14" />
    <rect x="2" y="7" width="13" height="10" rx="2" />
  </svg>
);

interface OrderSummaryProps {
  spread: Spread;
  calculatedPrice: number;
  express: boolean;
  isSingleQuestion: boolean;
  questionsCount?: number;
  isTherapy?: boolean;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({
  spread,
  calculatedPrice,
  express,
  isSingleQuestion,
  questionsCount = 1,
  isTherapy = false,
}) => (
  <div className="card fw-bold shadow bg-white mb-2">
    <div className="card-body">
      <div className="row">
        <div className="col-9 text-start">
          <h3 className="fw-bold">
            {spread.title}
            {express ? ' (Експресна поръчка)' : ''}
          </h3>
          <p>{spread.orderDescription}</p>
          {!isTherapy && (
            <p className="d-flex align-items-center mb-2">
              <ClockIcon />
              Срок за получаване:{' '}
              {express || isSingleQuestion ? 'до 24 часа' : '3 дни'}
            </p>
          )}
          <p className="d-flex align-items-center">
            {isTherapy ? <VideoIcon /> : <WarningIcon />}
            {isTherapy ? 'Видео консултация на живо' : 'Изпраща се само на видео'}
          </p>
        </div>
        <div className="col-3 col-sm-3 d-flex flex-column justify-content-center align-items-center ps-1">
          {isSingleQuestion && questionsCount > 1 && (
            <p className="text-muted small mb-1 text-center">
              {questionsCount} × {spread.price} EUR
            </p>
          )}
          <h1 className="fw-bolder m-0">{calculatedPrice} EUR</h1>
        </div>
      </div>
    </div>
  </div>
);

export default OrderSummary;
